import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateBrandModelComponent } from 'app/dialogs/create-brand-model/create-brand-model.component';
import { CreateProducts } from 'app/dtos/Product/createProducts';
import { AuthService } from 'app/services/auth.service';
import { BrandModelService } from 'app/services/models/brand-model.service';
import { BrandService } from 'app/services/models/brand.service';
import { CategoryService } from 'app/services/models/category.service';
import { CurrencyService } from 'app/services/models/currency.service';
import { ProductService } from 'app/services/models/product.service';
import { TaxService } from 'app/services/models/tax.service';
import { UnitTypeService } from 'app/services/models/unit-type.service';
import { WarehouseService } from 'app/services/models/warehouse.service';
import Stepper from 'bs-stepper';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-create-product',
  templateUrl: './create-product.component.html',
  styleUrls: ['./create-product.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateProductComponent implements OnInit {
  public productForm: FormGroup;

  constructor(
    private unitTypeService: UnitTypeService,
    private router: Router,
    private currencyService: CurrencyService,
    private taxService: TaxService,
    private categoryService: CategoryService,
    private warehouseService: WarehouseService,
    private produtService: ProductService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private brandService: BrandService,
    private modalService: NgbModal,
    public authService: AuthService) { }

  public contentHeader: object;
  public labels: string[] = [];
  public unitTypes: any[];
  public currencies: any[];
  public taxes: any[];
  public categories: any[];
  public warehoueses: any[];
  public products: any[];
  serialNumbers: any[] = [];
  brands: any[];

  public selectBasicLoading = false;

  isAdvancedChange: boolean = false;

  searchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.name?.toLowerCase().includes(term) || item.brandName?.toLowerCase().includes(term);
  }

  openCreateBrandModelDialog() {
    this.modalService.open(CreateBrandModelComponent, {
      animation: true,
      centered: true,
      windowClass: 'modal modal-success'
    });
  }

  async ngOnInit() {
    this.horizontalWizardStepper = new Stepper(document.querySelector('#stepper1'), {
      linear: false,
      animation: true
    })

    this.contentHeader = {
      headerTitle: 'Ürün Hizmet',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Ürün Hizmet Listesi',
            isLink: true,
            link: '/product'
          },
          {
            name: "Ürün Hizmet Ekle",
            isLink: false
          }
        ]
      }
    }

    this.productForm = this.fb.group({
      code: [null, [Validators.maxLength(16)]],
      name: [null, [Validators.required, Validators.maxLength(50)]],
      productType: [true],
      unitTypeId: [null],
      currencyId: [null],
      purchasePrice: [null],
      salePrice: [null],
      purchaseTaxId: [null],
      saleTaxId: [null],
      categoryId: [null],
      barcode: [null, [Validators.maxLength(20)]],
      criticalStock: [null],
      brandModalId: [null]
    });

    await this.getAllCurrency(0, 100, "");
    await this.getAllTax(0, 100, "");
    await this.getAllCategory(0, 100, "");
    await this.getAllWarehouse(0, 100, "");
    await this.getAllProduct(0, 100, "");
    await this.getAllBrand();
    await this.getAllUnitTypes(0, 100, "");


    this.brandService.event$.subscribe(async result => {
      await this.getAllBrand();
    })

  }

  async getAllBrand() {
    const data = await this.brandService.getBrands();
    // flatMap kullanarak tek katmanlı bir dizi oluşturuyoruz
    this.brands = data.flatMap(brand =>
      brand.brandModels.map(model => ({
        id: model.id,                // Modelin ID'sini ekliyoruz
        name: model.modelName,        // Model ismi
        brandName: brand.brandName    // Grup başlığı olarak marka ismi
      }))
    );

    console.log(this.brands);

  }

  toggleAdvancedUpload(event: any) {
    this.isAdvancedChange = event.target.checked;
  }

  addSerialNumber() {
    this.serialNumbers.push({ serialNumber: '' });
  }

  deleteSerialNumber(index: number) {
    this.serialNumbers.splice(index, 1);
  }


  private horizontalWizardStepper: Stepper;

  horizontalWizardStepperNext(stepId: string) {
    if (this.isStepValid(stepId)) {
      this.horizontalWizardStepper.next();
    } else {
      console.error('Step is not valid:', stepId);
    }
  }

  horizontalWizardStepperPrevious() {
    this.horizontalWizardStepper.previous();
  }

  isStepValid(stepId: string): boolean {
    const stepForm = this.getStepForm(stepId);
    console.log(stepForm ? stepForm.valid : false);
    return stepForm ? stepForm.valid : false;
  }

  getStepForm(stepId: string): FormGroup | null {
    // Burada adım ID'sine göre formu döndüren bir yöntem ekleyin.
    // Bu yöntem adım ID'sine göre uygun form grubunu döndürmelidir.
    return this.productForm;
  }

  preventSubmit(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  public items = [];

  addItem() {
    this.items.push({
      itemId: '',
      count: ''
    });
  }

  deleteItem(id) {
    for (let i = 0; i < this.items.length; i++) {
      if (this.items.indexOf(this.items[i]) === id) {
        this.items.splice(i, 1);
        break;
      }
    }
  }



  async onSubmit() {
    if (this.productForm.valid) {
      console.log(this.productForm.value);

      const connectedSubProductId = this.items.map(p => Number(p.itemId)); // itemId'yi number türüne dönüştür
      const subProductCount = this.items.map(p => Number(p.count));
      console.log(connectedSubProductId);
      console.log(subProductCount);
      this.productForm.value.productType = this.productForm.value.productType == 'true' ? true : false;
      console.log(this.serialNumbers);
      try {
        const resp = await this.produtService.createProduct({
          code: this.productForm.value.code,
          name: this.productForm.value.name,
          productType: this.productForm.value.productType,
          unitTypeId: this.productForm.value.unitTypeId,
          purchasePrice: this.productForm.value.purchasePrice,
          salePrice: this.productForm.value.salePrice,
          purchaseTaxId: this.productForm.value.purchaseTaxId,
          saleTaxId: this.productForm.value.saleTaxId,
          categoryId: this.productForm.value.categoryId,
          barcode: this.productForm.value.barcode,
          criticalStock: this.productForm.value.criticalStock,
          currencyId: this.productForm.value.currencyId,
          labels: this.labels,
          connectedSubProductId: connectedSubProductId,
          subProductCount: subProductCount,
          serialNo: this.serialNumbers.map(sn => sn.serialNumber),
          brandModalId: this.productForm.value.brandModalId
        });
        console.log(resp);
        if (resp.status == true) {
          this.router.navigate(['/admin/product'])
          this.toastrService.success(resp.message);
        } else {
          this.toastrService.error(resp.message);
        }
      } catch (error) {
        console.error('Error creating product:', error);
      }

    } else {
      this.toastrService.error("Gerekli yerleri doldurunuz.", "Form geçersiz.");
    }

  }

  addLabel(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      const inputElement = event.target as HTMLElement;
      const newLabel = inputElement.textContent?.trim();
      if (newLabel) {
        this.labels.push(newLabel);
        inputElement.textContent = ''; // Clear input after adding label
        inputElement.focus(); // Focus on the input area again
      }
    }
    console.log(this.labels)
  }

  removeLabel(label: string) {
    this.labels = this.labels.filter(l => l !== label);
  }

  async getAllUnitTypes(page, size, search) {
    this.selectBasicLoading = true;
    const data = await this.unitTypeService.getAllUnitType(page, size, search);
    console.log(data.unitTypes);
    this.unitTypes = data.unitTypes
    if(this.unitTypes){
      this.productForm.patchValue({
        unitTypeId: this.unitTypes[0].id
      })
    }
    this.selectBasicLoading = false;

  }

  async getAllCurrency(page, size, search) {
    this.selectBasicLoading = true;
    const data = await this.currencyService.getAllPageCurrency(0, 100, search);
    console.log(data);
    this.currencies = data.currenies
    this.productForm.patchValue({
      currencyId: this.currencies.find(currency => currency.currencyName === "TL")?.id
    })
    this.selectBasicLoading = false;

  }

  async getAllTax(page, size, search) {
    this.selectBasicLoading = true;
    const data = await this.taxService.getAllTax(0, 100, search);
    console.log(data);
    this.taxes = data.taxex
    this.selectBasicLoading = false;

  }

  async getAllCategory(page, size, search) {
    this.selectBasicLoading = true;
    const data = await this.categoryService.getAllCategory(0, 100, search, 1);
    console.log(data);
    this.categories = data.categories;
    this.selectBasicLoading = false;
  }

  async getAllWarehouse(page, size, search) {
    this.selectBasicLoading = true;
    const data = await this.warehouseService.getAllWarehouses(0, 100, search);
    console.log(data);
    this.warehoueses = data.warehouses;
    this.selectBasicLoading = false;
  }

  async getAllProduct(page, size, search) {
    this.selectBasicLoading = true;
    const data = await this.produtService.getAllProducts(0, 100, search);
    console.log(data);
    this.products = data.products;
    this.selectBasicLoading = false;
  }

  productsExcel: any[] = [];
  isProductsValid: boolean = false;
  allProductsValid: boolean = true;


  getByIdUnitType(unitTypes) {
    const unitType = this.unitTypes.find(p => p.unitTypeName.toLowerCase() == unitTypes.toLowerCase());
    return unitType;
  }

  getByIdCategories(categoryName) {
    const category = this.categories.find(p => p.categoryName.toLocaleLowerCase('tr-TR') == categoryName.toLocaleLowerCase('tr-TR'));
    return category;
  }

  getByIdTaxes(taxRate) {
    const tax = this.taxes.find(p => p.taxRate == taxRate);
    return tax;
  }

  getByIdCurrency(currencyName: string | null | undefined) {
    if (!currencyName || typeof currencyName !== 'string') {
      console.error('Invalid currencyName:', currencyName);
      return null; // Veya uygun bir varsayılan değer döndürün
    }
  
    const currency = this.currencies.find(
      p => p.currencyName === currencyName.toUpperCase()
    );
  
    if (!currency) {
      console.warn(`Currency not found for name: ${currencyName}`);
    }
  
    return currency;
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: 'binary' });

      // İlk sayfayı al
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      // Verileri JSON formatına çevir
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Sütun başlıklarını ayarlamak için
      const products = jsonData.slice(1).map(row => {

        const currency = row[3] ? this.getByIdCurrency(row[3]) : null;
        if (row[3] && !currency) {
          this.toastrService.error(`Para birimi "${row[3]}" bulunamadı. Lütfen geçerli bir para birimi girin.`, "Para Bulunamadı!", {
            timeOut: 3000
          });
          this.allProductsValid = false;
        }

        const purchaseTax = row[4] ? this.getByIdTaxes(row[4]) : null; // Vergi oranı için uygun fonksiyonu kullan
        if (row[4] && !purchaseTax) {
          this.toastrService.error(`Böyle bir vergi bulunamadı. Excel'den bilgiyi silin veya vegilere ekleyin. : ${row[4]}`, "Vergi Bulunamadı!", {
            timeOut: 4000
          });
          this.allProductsValid = false;
        }

        const saleTax = row[5] ? this.getByIdTaxes(row[5]) : null // Vergi oranı için uygun fonksiyonu kullan
        if (row[5] && !saleTax) {
          this.toastrService.error(`Böyle bir vergi bulunamadı. Excel'den bilgiyi silin veya vegilere ekleyin. : ${row[5]}`, "Vergi Bulunamadı!", {
            timeOut: 5000
          });
          this.allProductsValid = false;
        }

        const category = row[6] ? this.getByIdCategories(row[6]) : null // Vergi oranı için uygun fonksiyonu kullan
        if (row[6] && !category) {
          this.toastrService.error(`Böyle bir kategori bulunamadı. Excel'den bilgiyi silin veya kategorilere ekleyin: ${row[6]}`, "Kategori Bulunamadı!", {
            timeOut: 6000
          });
          this.allProductsValid = false;
        }

        const unitType = row[7] ? this.getByIdUnitType(row[7]) : null // Vergi oranı için uygun fonksiyonu kullan
        if (row[7] && !unitType) {
          this.toastrService.error(`Böyle bir Birim bulunamadı. Excel'den bilgiyi silin veya Birimlere ekleyin: ${row[7]}`, "Kategori Bulunamadı!", {
            timeOut: 7000
          });
          this.allProductsValid = false;
        }

        return {
          name: row[0], // Ürün adı
          salePrice: row[1], // Satış fiyatı
          purchasePrice: row[2], // Alış fiyatı
          currency: currency, // Para birimi
          purchaseTax: purchaseTax,
          saleTax: saleTax,
          categori: category,
          unitType: unitType,
          productType: row[8] && row[8].toLowerCase() === 'ürün'
        };
      }).filter(product => {
        // Check if all fields in the product are null or undefined
        return product.name || product.salePrice || product.purchasePrice || product.productType;
      });

      const invalidProducts = products.filter(product =>
        !product.name ||
        typeof product.salePrice !== 'number' ||
        typeof product.purchasePrice !== 'number' ||
        product.productType === undefined
      );

      this.isProductsValid = invalidProducts.length > 0 ? false : true;

      if (invalidProducts.length > 0) {
        this.toastrService.error('Bazı ürünler uygun olmayan biçimde.');
      }

      this.productsExcel = products;

      console.log(this.productsExcel);
    };

    reader.readAsBinaryString(file);
  }

  resetFileInput(fileInput: HTMLInputElement) {
    // Dosya girişi temizle
    fileInput.value = '';
    this.productsExcel = [];
    this.isProductsValid = false;
    this.allProductsValid = true;
  }

  async saveProducts() {
    if (!this.isProductsValid) {
      this.toastrService.error('Lütfen geçerli ürünler yükleyin.');
      return;
    } else {
      this.productsExcel = this.productsExcel.map(product => {
        const createProduct: CreateProducts = {
          name: product.name.trim(), // Trim whitespace
          productType: product.productType,
          unitTypeId: product.unitType?.id ?? null, // Use optional chaining
          currencyId: product.currency?.id ?? null, // Use optional chaining
          purchasePrice: product.purchasePrice ?? null,
          salePrice: product.salePrice ?? null,
          purchaseTaxId: product.purchaseTax?.id, // Assumes this field is required
          saleTaxId: product.saleTax?.id, // Assumes this field is required
          categoryId: product.categori?.id ?? null // Use optional chaining
        };
        return createProduct;
      });
      console.log(this.productsExcel);
      const response = await this.produtService.createProducts(this.productsExcel);
      if (response.status) {
        this.toastrService.success(response.message);
        this.router.navigate(['/admin/product'])
      } else {
        this.toastrService.error(response.message);
      }
    }
  }
}